import { observer } from 'mobx-react';
import { FormStore } from 'Mri.Web.Common';
import * as React from 'react';
import { Form, FormGroup } from 'reactstrap';
import { ActiveDisplay } from '../../ActiveDisplay';
import { DisplayFormConnection } from './DisplayFormConnection';
import { DisplayFormDetails } from './DisplayFormDetails';
import { DisplayFormLocation } from './DisplayFormLocation';

export interface IDisplayFormProps {
    readonly displayForm: FormStore<Mri.Web.Internal.Controllers.Displays.UpdateDisplayModel>;
    readonly display: ActiveDisplay;
    readonly displayLoginPoll: Mri.DisplaySystem.DisplayLoginPoll;
}

@observer
export class DisplayForm extends React.Component<IDisplayFormProps> {
    public render() {
        const { displayForm, display, displayLoginPoll } = this.props;
        return (
            <Form>
                <FormGroup>
                    <div className="container-fluid p-0">
                        <div className="row">
                            <DisplayFormDetails displayForm={displayForm} />
                            <DisplayFormLocation displayForm={displayForm} display={display} />
                            <DisplayFormConnection displayForm={displayForm} displayLoginPoll={displayLoginPoll} />
                        </div>
                    </div>
                </FormGroup>
            </Form>
        );
    }
}
